import './App.scss';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './Layout/Layout';
import Home from './Pages/Home';
import ChapterOne from './Pages/ChapterOne';
import ChapterTwo from './Pages/ChapterTwo';
import Commodity from './Pages/Commodity';
import ImportantConcepts from './Pages/ImportantConcepts';
import PageRoutes from './Config/PageRoutes';
import MenuContextProvider from './store/MenuContextProvider';
import ScrollToTop from './Utility/ScrollToTop';
import './fonts/index.css';

const App = () => {
	return (
		<MenuContextProvider>
			<BrowserRouter basename='/pesticides-report-2023'>
				<ScrollToTop />
				<Routes>
					<Route path={PageRoutes.CHAPTER_ONE} element={<Layout />}>

						<Route index path={PageRoutes.CHAPTER_ONE} element={<ChapterOne />} />
						<Route path={PageRoutes.CHAPTER_TWO} element={<ChapterTwo />} />
						<Route
							path={PageRoutes.IMPORTANT_CONCEPTS}
							element={<ImportantConcepts />}
						/>
						<Route path={PageRoutes.COMMODITY} element={<Commodity />} />
						<Route
							path='*'
							element={<Navigate to={PageRoutes.CHAPTER_ONE} replace />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
		</MenuContextProvider>
	);
};

export default App;

